import React from 'react';
import PropTypes from 'prop-types';
import { default as MuiBox } from '@mui/material/Box';

/**
 * A basic layout component with the `sx` prop
 * @done true
 * @updated v7.10.0
 * @versionAdded v7.10.0
 * @examples
 *  BasicExample
 *  PromotionExample
 */
var Box = function Box(props) {
  return /*#__PURE__*/React.createElement(MuiBox, props);
};
Box.muiName = 'Box';
Box.propTypes = {
  /**
   * The component used for the root node. Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * 	The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
};
export default Box;